import React, { useRef, useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import {
  Button,
  Input,
  InputFile,
  Picker,
  Row,
  SelectForm,
  Line
} from 'components'
import {
  DraggableDialog,
  resetModalState
} from 'components/DraggableDialog/DraggableDialog'
import Draggable from 'react-draggable'
import { useForm } from 'react-hook-form'
import { CollpaseContrato } from 'services/Supplier/ThirdPartyAdministration'
import { SPACING } from 'utils'
import { TipoPendencia } from 'utils/types'
import * as Yup from 'yup'

import {
  DialogActionsStyled,
  DialogContentStyled,
  DialogTitleStyled,
  FormDialog
} from './ModalNewGst.styles'
interface IModalNewGst {
  open?: boolean
  handleModal?: () => void
  onSubmit?: (_data: any) => void
  documentTypes: TipoPendencia[]
  selectedContract: CollpaseContrato
}

export interface FormNewGST {
  dtCompetencia: Date
  txTipo: string
  dtAcesso: string
  txJust?: string
}

const schema = Yup.object({
  txTipo: Yup.string().required('Tipo documento é obrigatório')
})

const ModalNewGst: React.FC<IModalNewGst> = ({
  handleModal,
  documentTypes,
  open,
  onSubmit,
  selectedContract
}) => {
  const { handleSubmit, formState, control, reset } = useForm<FormNewGST>({
    resolver: yupResolver(schema)
  })

  const [filesUp, setFilesUp] = useState<File[] | undefined>()
  const [inputFileError, setInputFileError] = useState<string>('')

  const handleSubmitForm = (form) => {
    setInputFileError('')

    if (!filesUp) {
      setInputFileError('Você deve anexar um arquivo')
      return
    }

    onSubmit({ ...form, files: filesUp })
    reset()
    handleModal()
  }

  const draggableReference = useRef<Draggable>(null)

  return (
    <DraggableDialog
      reference={draggableReference}
      showModal={open}
      onClose={handleModal}
      width="md"
    >
      <FormDialog
        onSubmit={(submitData) => {
          handleSubmit(handleSubmitForm)(submitData).then(() => {
            resetModalState(draggableReference)
          })
        }}
      >
        <Line />
        <DialogTitleStyled>Novo Documento</DialogTitleStyled>
        <DialogContentStyled>
          <Row alignItems="center">
            <Input
              value={selectedContract?.cdContrato}
              label="Contrato"
              placeholder="Nº"
            />
            <Input
              value={selectedContract?.cdDocumento}
              label="CNPJ"
              marginLeft={SPACING.spacing15}
              marginRight={SPACING.spacing15}
              placeholder="Nº"
            />
            <Input
              value={selectedContract?.nmFornecedor}
              label="Fornecedor"
              placeholder="Nome do Fornecedor"
            />
          </Row>
          <Row
            alignItems="center"
            marginBottom={SPACING.spacing20}
            marginTop={SPACING.spacing20}
          >
            <Picker
              control={control}
              defaultValue={new Date()}
              formValue="dtCompetencia"
              label="Competência"
              placeholder="mm/aaaa"
            />
            <SelectForm
              control={control}
              errors={formState.errors}
              formValue="txTipo"
              label="Tipo Documento"
              labelMenu="txDescricao"
              valueMenu="idTipoPendencia"
              listOptions={documentTypes.length > 0 && documentTypes}
              placeholder="Selecione"
              marginLeft={SPACING.spacing15}
              marginRight={SPACING.spacing15}
            />
            <Picker
              defaultValue={new Date()}
              control={control}
              formValue="dtAcesso"
              label="Data Acesso"
              placeholder="dd/mm/aaaa"
            />
          </Row>
          <Row alignItems="center">
            <InputFile
              placeholder="Selecione um ou mais arquivos."
              value={filesUp}
              onChange={(e) => setFilesUp(e)}
              error={inputFileError}
            />
          </Row>
        </DialogContentStyled>
        <DialogActionsStyled>
          <Button text="Limpar" variantButton="text" onClick={() => reset()} />
          <Button
            text="Voltar"
            onClick={() => {
              handleModal()
              reset()
            }}
            variantButton="outlined"
          />
          <Button text="Enviar" type="submit" />
        </DialogActionsStyled>
      </FormDialog>
    </DraggableDialog>
  )
}

export default ModalNewGst
